import { usePermissionsBatchV2Query } from "src/graphql";

import type { V2ResourceToPermission } from "./types-v2";

export type UpdatableResource = {
  resource: Extract<
    V2ResourceToPermission,
    "model" | "source" | "destination" | "sync" | "realtime_audience_sync"
  >;
  id: string | number;
};

/*
 * Checks `can_update` on every resource in one batch request, for bulk actions
 * that should only be offered when they can succeed for the whole selection.
 */
export function useCanUpdateResources(resources: UpdatableResource[]): {
  isPermitted: boolean;
  isLoading: boolean;
} {
  const { data: isPermitted, isLoading } = usePermissionsBatchV2Query(
    {
      inputs: resources.map(({ resource, id }) => ({
        v2: { resource, grant: "can_update", id: id.toString() },
      })),
    },
    {
      enabled: resources.length > 0,
      meta: { isFastEndpoint: true },
      select: (data) =>
        data.isResourcesAuthorized.length === resources.length &&
        data.isResourcesAuthorized.every((result) => result?.isAuthorized),
    },
  );

  return {
    isPermitted: Boolean(isPermitted),
    isLoading: resources.length > 0 && isLoading,
  };
}
